export const LOCAL_STORAGE_TEXT_SETTINGS = 'textSettings2';
export const LOCAL_STORAGE_IMAGE_SETTINGS = 'imageSettings2';
export const LOCAL_STORAGE_CUSTOM_FONT = 'customFontData';
